export const projectPath = issue => issue.fullReference.split('#')[0];

export const issueIid = issue => issue.fullReference.split('#')[1];

export const topLevelGroup = issue => projectPath(issue).split('/')[0];

const projectSlug = path => path.split('/').at(-1);

const findClashingNames = (paths) => {
  const seenNames = new Set();
  const clashingNames = new Set();

  for (const path of paths) {
    const name = projectSlug(path);

    if (seenNames.has(name)) {
      clashingNames.add(name);
    }

    seenNames.add(name);
  }

  return clashingNames;
};

// Projects are identified by slug so users don't have to type a full path.
// Some slugs clash, so we keep their full path to stay distinguishable.
export const buildProjectDisplayNames = (projectPaths) => {
  const paths = [...new Set(projectPaths)];
  const clashingNames = findClashingNames(paths);

  return new Map(paths.map((path) => {
    const name = projectSlug(path);

    return [path, clashingNames.has(name) ? path : name];
  }));
};
